<template>
    <div>
        <div
            class="modal fade bd-example-modal-lg"
            id="error-logs-preview-modal"
            tabindex="-1"
            role="dialog"
            data-backdrop="static"
            aria-labelledby="errorLogsPreviewModalLabel"
            aria-hidden="true"
            :class="{ show: view }"
            :style="{ display: view ? 'block' : 'none' }"
        >
            <div class="modal-dialog modal-dialog-centered modal-large" role="document">
            <div class="modal-content">
                <div class="modal-header text-center">
                <div class="d-flex justify-content-between w-100 align-items-center">
                    <h4 class="modal-title" id="errorLogsPreviewModalLabel">Error log detail</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" @click="close">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div class="modal-body">
                  <div v-if="data">
                    <div class="container email-like">
                      <div class="card">
                        <div class="card-header">Se detectó un error {{ firstMessageLine }} - {{ customerName }}</div>
                        <div class="card-body">
                          <div class="meta"><strong>URL:</strong> <a :href="data.URL" target="_blank" rel="noopener noreferrer">{{ data.URL }}</a></div>
                          <div class="meta"><strong>Usuario:</strong> {{ data.User || 'Usuario desconocido' }}</div>
                          <div class="meta"><strong>Dispositivo:</strong> {{ data.Device || 'Dispositivo desconocido' }}</div>
                          <div class="meta"><strong>Navegador:</strong> {{ data.Browser || 'Navegador desconocido' }}</div>
                          <div class="meta"><strong>Cliente:</strong> {{ customerName }}</div>
                          <div class="meta"><strong>Timestamp:</strong> <span class="pill">{{ formattedTimestamp }}</span></div>

                          <div class="section">
                            <h4>Mensaje</h4>
                            <pre>{{ firstMessageLine }}</pre>
                          </div>

                          <div class="section" v-if="stackText">
                            <h4>Stack trace</h4>
                            <pre>{{ stackText }}</pre>
                          </div>
                          <div class="section" v-if="data.Logs">
                            <h4>Logs</h4>
                            <pre>{{ parsedLogs.join('\n') }}</pre>
                          </div>
                          <div class="section" v-if="prettyJson">
                            <h4>JSON completo para debugging</h4>
                            <pre>{{ prettyJson }}</pre>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            </div>
        </div>
        <div v-if="view" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
    name: 'error-logs-preview-modal',
  props: {
    data: { type: Object, default: null },
    view: { type: Boolean, default: false }
  },
    data () {
        return {
            // Component data
        }
    },
  watch: {
    view (val) {
      if (typeof document !== 'undefined') {
        document.body.classList.toggle('modal-open', !!val);
      }
    }
  },
  mounted () {
    if (this.view && typeof document !== 'undefined') {
      document.body.classList.add('modal-open');
    }
  },
  beforeDestroy () {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('modal-open');
    }
  },
    methods: {
        close () {
      this.$emit('update:view', false);
        },
    },
    computed: {
      customerName () {
        // data.Customer may be object or string
        const c = this.data && this.data.Customer;
        if (!c) return 'Cliente no identificado';
        if (typeof c === 'string') return c;
        return c.Name || c.name || 'Cliente no identificado';
      },
      formattedTimestamp () {
        const raw = this.data && (this.data.CreatedUTCRaw || this.data.CreatedUTC);
        try {
          return raw ? new Date(raw).toLocaleString() : '';
        } catch (e) {
          return this.data && this.data.CreatedUTC ? String(this.data.CreatedUTC) : '';
        }
      },
      stackText () {
        const s = (this.data && this.data.Stack) || '';
        if (!s) return '';
        return s
          .split('\n')
          .filter(x => x && x.trim())
          .join('\n');
      },
      firstMessageLine () {
        const s = (this.data && this.data.Stack) || '';
        if (!s) return 'Mensaje de error no disponible';
        const first = s.split('\n')[0];
        return first || 'Mensaje de error no disponible';
      },
      prettyJson () {
        try {
          const payload = {
            url: (this.data && this.data.URL) || 'URL no disponible',
            error: {
              message: this.firstMessageLine,
              stack: this.stackText ? this.stackText.split('\n') : [],
              logs: (this.data && this.data.Logs) || 'Logs no disponibles'
            },
            user: (this.data && this.data.User) || 'Usuario desconocido',
            device: (this.data && this.data.Device) || 'Dispositivo desconocido',
            browser: (this.data && this.data.Browser) || 'Navegador desconocido',
            customer: this.customerName,
            timestamp: (this.data && (this.data.CreatedUTCRaw || this.data.CreatedUTC)) || ''
          };
          return JSON.stringify(payload, null, 2);
        } catch (e) {
          return '';
        }
      },
      parsedLogs() {
      try {
        if (Array.isArray(this.data.Logs)) return this.data.Logs;
        return JSON.parse(this.data.Logs);
      } catch (e) {
        return [this.data.Logs];
      }
    }
    }
}
</script>

<style scoped>
.modal-dialog{
    overflow-y: initial !important
}
/* Email-like styles to match backend template */
.email-like{max-width:760px;margin:16px auto;padding:0 12px}
.email-like .card{background:#ffffff;border:1px solid #e5e7eb;border-radius:10px;box-shadow:0 2px 6px rgba(0,0,0,0.06);overflow:hidden}
.email-like .card-header{background:#0ea5e9;color:#fff;padding:14px 18px;font-weight:600;font-size:16px}
.email-like .card-body{padding:18px}
.email-like .meta{display:block;margin:0 0 10px 0}
.email-like .meta strong{color:#111827}
.email-like .meta a{color:#0ea5e9;text-decoration:none;word-break:break-all}
.email-like .section{margin-top:14px}
.email-like .section h4{margin:0 0 8px 0;font-size:14px;color:#111827}
.email-like pre{background:#0f172a;color:#e5e7eb;border-radius:8px;border:1px solid #111827;padding:12px;overflow:auto;white-space:pre-wrap;word-wrap:break-word;font-family:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, monospace;font-size:12px;line-height:1.45}
.email-like .pill{display:inline-block;background:#eef2ff;color:#3730a3;border:1px solid #c7d2fe;border-radius:999px;padding:2px 10px;font-size:12px}
</style>
